import React from 'react'
import { cn } from '@/lib/utils'
import Image from 'next/image'

export const Header: React.FC = () => (
  <header className={cn('appHeader', 'max-w-full md:max-w-4xl')}>
    <Image
      src="/assets/svg/logo.svg"
      alt="CrawlHawk"
      width={400}
      height={300}
      className="max-md:max-w-[60px]"
    />
    <h1 className="gradient-text-white max-md:text-3xl">CrawlHawk.com</h1>
  </header>
)
